
define('utility/method-loader',[],function () {
    'use strict';
    // this is a plugin class that allows loading of multiple methods with a common purpose, sort of like a package. 
    // Allows for loading only the methods that are used in each module.

    function MethodLoader (defaultPrefix, methodToModule) {

        this.load = function (name, parentRequire, load, config) {
            var methods = name.split(',');

            var moduleNames = methods.map(function (methodName) {
                return methodToModule[methodName] ||
                    // default to `string.{methodName}` in the same directory
                    (defaultPrefix + methodName);
            });

            parentRequire(moduleNames, function () {
                // construct object with desired methods
                var result = {},
                    args = arguments;
                moduleNames.forEach(function (moduleName, i) {
                    result[methods[i]] = args[i];
                });
                load(result);
            });

        };

        this.normalize = function (name, normalize) {
            // sort method names to prevent excess permutations from creating new module objects
            var methods = name.trim().split(/\s*,\s*/);
            methods.sort();
            return methods.join(',');
        };
    }

    return MethodLoader;
});